<div class="progressBar">
  <div
    role="progressbar"
    class="progressBar__progress"
    [ngClass]="{
      'progressBar--small': ppSize === 'small',
      'progressBar--normal': ppSize === 'normal',
    }"
    [style.width]="ppProgress + '%'"
  ></div>

  <div
    class="progressbar__content"
    [ngClass]="{
      'progressbar__content--small': ppSize === 'small',
      'progressbar__content--normal': ppSize === 'normal',
    }"
  >
    <ng-content></ng-content>
  </div>

  @if (ppPending) {
    <button type="button" class="progressBar__cancel-upload" (click)="action()">
      <pp-icon
        [ppSrc]="EIconPath.ICON_MISC_CLOSE_14"
        ppClass="setSize14"
        ppColor="inherit"
      ></pp-icon>
    </button>
  }
</div>
